// Dependencies
import { Component, ReactNode } from 'react';

import Icon from 'components/atoms/Icon';
import { twclsx } from 'utils/twclsx';

export default class ManagerBase<P extends { [key: string]: any }, S extends { [key: string]: any }> extends Component<
    P,
    S
> {
    renderPages = () => {
        const elements: ReactNode[] = [];
        const { page, pages } = this.state;

        const from = page - 3 > 1 ? page - 3 : 1;
        const to = page + 3 < pages ? page + 3 : pages;

        if (page > 3) {
            elements.push(
                <span
                    key={0}
                    className="-mt-px pb-3 border-t-2 border-transparent pt-4 px-2 inline-flex items-center  leading-5 font-medium text-gray-700"
                >
                    ...
                </span>
            );
        }

        for (let index = from; index <= to; index++) {
            if (index === page) {
                elements.push(
                    <div
                        key={index}
                        className="-mt-px border-b-2 pb-3 border-blue-500 pt-4 px-2 inline-flex items-center  leading-5 font-medium text-blue-600 focus:outline-none focus:text-blue-800 focus:border-blue-700 transition ease-in-out duration-150"
                    >
                        {index}
                    </div>
                );
            } else {
                elements.push(
                    <div
                        key={index}
                        onClick={() => this.changepage(index)}
                        className="cursor-pointer pb-3 -mt-px border-b-2 border-transparent pt-4 px-2 inline-flex items-center leading-5 font-medium text-gray-700 hover:text-gray-700 hover:border-gray-400 focus:outline-none focus:text-gray-700 focus:border-gray-500 transition ease-in-out duration-150"
                    >
                        {index}
                    </div>
                );
            }
        }

        if (page - 3 < pages && pages > 3) {
            elements.push(
                <span
                    key={pages + 1}
                    className="-mt-px pb-3 border-t-2 border-transparent pt-4 px-2 inline-flex items-center  leading-5 font-medium text-gray-700"
                >
                    ...
                </span>
            );
        }

        return elements;
    };

    dateFormater = (date) => {
        return this.props.dateTimeFormat.parseDateTime(date).formatDateTimeToString('dd LLL yyyy HH:mm Z');
    };

    search = (name: string, value: string) => {
        if (value.length >= 3) {
            const searchQuery = {};
            this.state.searchFor.forEach((searchElment) => {
                searchQuery[searchElment] = value;
            });
            //@ts-ignore
            this.setState({ searchQuery: searchQuery, searchValue: value }, this.getData);
        } else if (value.length == 0) {
            const searchQuery = {};
            this.state.searchFor.forEach((searchElment) => {
                searchQuery[searchElment] = '';
            });
            //@ts-ignore
            this.setState({ searchQuery: searchQuery, searchValue: value }, this.getData);
        }
        //@ts-ignore
        this.setState({ searchValue: value });
    };

    setFilter = (filterQuery) => {
        this.setState({ filterQuery }, this.getData);
    };

    renderOrder = (type) => {
        if (type !== this.state.order.type) {
            return (
                <svg
                    onClick={() => this.addOrder(type)}
                    className="w-3 orderLocation mr-1 cursor-pointer float-left order"
                    viewBox="0 0 1792 1792"
                >
                    <path
                        fill="#a0aec0"
                        d="M1408 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45zm0-384q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"
                    />
                </svg>
            );
        } else {
            switch (this.state.order.order) {
                case 'desc':
                    return (
                        <svg
                            onClick={() => this.addOrder(type)}
                            className="w-3 orderLocation mr-1 cursor-pointer float-left order"
                            viewBox="0 0 1792 1792"
                        >
                            <path d="M1408 704q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z" />
                        </svg>
                    );
                case 'asc':
                    return (
                        <svg
                            onClick={() => this.addOrder(type)}
                            className="w-3 orderLocation mr-1 cursor-pointer float-left order"
                            viewBox="0 0 1792 1792"
                        >
                            <path d="M1408 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z" />
                        </svg>
                    );
                default:
                    return (
                        <svg
                            onClick={() => this.addOrder(type)}
                            className="w-3 orderLocation mr-1 cursor-pointer float-left order"
                            viewBox="0 0 1792 1792"
                        >
                            <path
                                fill="#a0aec0"
                                d="M1408 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45zm0-384q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"
                            />
                        </svg>
                    );
            }
        }
    };

    toggleFilter = () => {
        // ovride by controller
    };

    renderFilter = (type) => {
        return (
            <div onClick={this.toggleFilter} className="cursor-pointer mr-1">
                <Icon
                    className={twclsx(
                        'h-4',
                        'w-4',
                        Object.keys(this.state.filterQuery).includes(type) ? 'text-primary-link' : 'text-gray-400'
                    )}
                >
                    <path d="M4 4h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v7l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227z" />
                </Icon>
            </div>
        );
    };

    changepage = (page: number) => {
        this.setState(
            //@ts-ignore
            {
                page,
            },
            this.getData
        );
    };

    getData = () => {
        //to be ovride by main component
    };

    addOrder = (type) => {
        let temp = this.state.order;
        if (temp.type === type) {
            temp.order = temp.order == 'desc' ? 'asc' : 'desc';
        } else {
            //@ts-ignore
            temp = { type: type, order: 'desc' };
        }
        //save order to state
        this.setState(
            //@ts-ignore
            {
                order: temp,
            },
            this.getData
        );
    };
}
